import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./custom.scss"; // Custom Bootstrap with Sweap colors
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import logger from "./utils/logging";
import { initConfig } from "./init/config";
import { wire } from "./init/wire";
import { unwrapDecoding } from "./utils/unwrap";
import { PRODUCT_NAME } from "./product";
import "./i18n"; // Initialize i18n

window.onerror = function (message, source, lineno, colno, error) {
    logger.error("Global error:", { message, source, lineno, colno, error });
};
// Type assertion needed because getElementById returns HTMLElement | null,
// but createRoot expects HTMLElement. We know 'root' exists in public/index.html
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

// Initialize dependencies using the backend pattern
const initializeApp = async () => {
    try {
        // Fetch and validate config
        const rawConfig = await fetch("/config.json")
            .then((res) => res.json())
            .catch(() => ({}));
        const config = unwrapDecoding(initConfig(rawConfig));

        // Wire dependencies
        const dependencies = wire(config);

        logger.info(
            `${PRODUCT_NAME} initialized for ${dependencies.config.environment} - version ${dependencies.config.appVersion}`,
        );
        // Render app with dependencies
        root.render(
            <React.StrictMode>
                <BrowserRouter>
                    <App dependencies={dependencies} />
                </BrowserRouter>
            </React.StrictMode>,
        );
    } catch (error) {
        logger.error("Failed to initialize application:", error);

        // Render error state
        root.render(
            <div style={{ padding: "2rem", textAlign: "center" }}>
                <h1>Application Failed to Load</h1>
                <p>Configuration error: {error instanceof Error ? error.message : "Unknown error"}</p>
            </div>,
        );
    }
};

initializeApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
